import statsApi from '@/api/statistic';

const SET_IS_FETCHING = 'SET_IS_FETCHING';
const SET_IS_FETCHED = 'SET_IS_FETCHED';
const SET_DECREASE_ASK_STOCK = 'SET_DECREASE_ASK_STOCK';
const SET_INCREASE_ASK_STOCK = 'SET_INCREASE_ASK_STOCK';
const SET_STATISTIC = 'SET_STATISTIC';

const state = {
	isFetching: false,
	isFetched: false,
	statistic: {},
};

const getters = {
	statistic: state => state.statistic,
	isFetching: state => state.isFetching,
	getAskStockNewCount: state => state?.statistic?.ask_stocks?.ask_stock_new_count,
};

const mutations = {
	[SET_DECREASE_ASK_STOCK](state, value) {
		state.statistic.ask_stocks.ask_stock_new_count -= value;
	},
	[SET_INCREASE_ASK_STOCK](state, value) {
		state.statistic.ask_stocks.ask_stock_new_count += value;
	},
	[SET_IS_FETCHING](state, status) {
		state.isFetching = status;
	},
	[SET_IS_FETCHED](state, status) {
		state.isFetched = status;
	},
	[SET_STATISTIC](state, data) {
		state.statistic = data;
	},
};

const actions = {
	getStatistic({ commit, getters }, data) {
		if (!getters.isFetching) {
			commit(SET_IS_FETCHING, true);
			const callback = (response) => {
				const statistics = response.data || [];
				if (statistics.length !== 0) {
					commit(SET_STATISTIC, statistics);
				}
				commit(SET_IS_FETCHING, false);
				commit(SET_IS_FETCHED, true);
				data.callback();
			};
			const errorCallback = (e) => {
				// eslint-disable-next-line
				console.log(e);
				data.errorCallback();
				commit(SET_IS_FETCHING, false);
				commit(SET_IS_FETCHED, true);
			};
			statsApi.getAppStatsNew(data.params, callback, errorCallback, data.sourceToken);
		}
	},
	decreaseAskStock({ commit }, value) {
		commit(SET_DECREASE_ASK_STOCK, value);
	},
	increaseAskStock({ commit }, value) {
		commit(SET_INCREASE_ASK_STOCK, value);
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
